import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = React.forwardRef(function PasswordInput(props, ref) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="password-input-wrapper">
      <input ref={ref} type={visible ? 'text' : 'password'} {...props} style={{ paddingRight: 36, ...props.style }} />
      <button
        type="button"
        className="password-toggle-btn"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
